module.exports = __webpack_public_path__ + "static/img/etherplant.e6ec773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/full/projects/etherplant.png
// module id = bV1w
// module chunks = 0